import { Component } from "@angular/core";
import { Observable } from "rxjs";
import { IUser } from "src/app/interfaces";
import { NavigationService } from "src/app/services";
@Component({
    selector: "user-admin-view",
    templateUrl: "./admin-view.component.html",
    standalone: false
})
export class AdminViewComponent {
  public user$: Observable<IUser[]>;

  constructor(private navService: NavigationService) {}
  onEdit(s: IUser): void {
    this.navService.toAdminUserRoleEdit(s.id);
  }
}
